import { FlexibleRockBottomModel } from '@services/flexible_component/mod';

interface Props {
	component: FlexibleRockBottomModel;
}

// const elements = {};

export function FlexibleRockBottom(_: Props): JSX.Element {
	return <div data-testid='FlexibleRockBottom' />;
}
